<template>
  <div class="card">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <h1 class="title has-text-centered mgb-20px">
        {{ messHeader }}
      </h1>
      <error-msg-component
        :messages="messagesPopup"
        :error="isErrorPopup"
        :champsVide="champsVide"
        :messagesChampsVide="messagesChampsVide"
        :title="'general.problemOccurred'"
        :withEmplyFields="true"
        @close="modifyIsErrorPopup"/>

      <section class="mgt-10px">
        <b-field
          class="obligatoire"
          :label="$t('listeOtImpression.popUpSelectionTechnicien.selectTechnicien')">
          <b-autocomplete
            v-model="technicienNom"
            :data="filteredTechniciens"
            field="decorator.nomPrenom"
            @select="selectTechnicien"
            @input="onTechnicienInputChange"
            :open-on-focus="true"
            icon="magnify">
          </b-autocomplete>
        </b-field>
      </section>
      <section class="columns is-vcentered mgt-10px">
          <qd-switch class="column is-1 is-switch-centered mgt-28px"
          v-model="etat.prisEnCompteEtat">
          </qd-switch>
          <b-field
            class="column mg-0"
            :class="{
              obligatoire: etat.prisEnCompteEtat,
              'is-6': needDate,
              'is-11': !needDate
              }"
            :label="$t('listeOtImpression.popUpSelectionTechnicien.etatSouhaite')">
            <b-select
              v-model="etat.etatSouhaite"
              expanded
              @input="handleEtatChanges">
              <option v-for="etat in LIST_ETAT_OT_TECH"
                      :key="etat.code"
                      :value="etat.code">
                {{ $t(etat.libelle) }}
              </option>
            </b-select>
          </b-field>
          <b-field
            v-if="needDate"
            class="column is-5 obligatoire"
            :label="labelDate">
            <b-datepicker show-week-number
                          v-model="etat.dateOt"
                          icon="calendar-today"
                          nearby-selectable-month-days
                          :editable="true"
                          @input="etat.prisEnCompteEtat = true">
            </b-datepicker>
          </b-field>
        </section>

      <footer class="mgt-20px">
        <div class="has-text-centered">
          <button
            class="button btn-modal-annuler is-cancel has-text-centered mg-button-modal"
            @click="cancel">
            {{ $t('general.button.cancel') }}
          </button>
          <button
            class="button is-warning has-text-centered mg-button-modal"
            @click="validate">
            {{ $t('general.button.valider') }}
          </button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import validationGeneral from '@/services/validation/validation';
import { prendreEnCharge } from '@/api/logistique/ordreTravailImpression';
import translate from '@/services/logistique/ordreTravail/tech/validation/translate';
import validation from '@/services/logistique/ordreTravail/tech/validation/validation';
import messageSucces from '@/services/general/messageSucces';
import { ETAT_A_EXPEDIER, LIST_ETAT_OT_TECH } from '@/configuration/logistique/ordreTravail/ordreTravailConf';
import { ETAT_PLANIFIE, ETAT_REALISE } from '@/configuration/logistique/audit/auditConf';
import formatDate from '@/services/general/formatIsoDate';

const User = createNamespacedHelpers('user');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'popUpTechnicienSelect',
  components: {
    errorMsgComponent,
  },
  data() {
    return {
      technicienNom: '',
      selectedTechnicien: null,
      messagesPopup: [],
      isErrorPopup: false,
      champsVide: [],
      messagesChampsVide: [],
      etat: {
        prisEnCompteEtat: true,
        etatSouhaite: ETAT_A_EXPEDIER,
        dateOt: null,
      },
      LIST_ETAT_OT_TECH,
    };
  },
  props: {
    messHeader: {
      type: String,
      required: true,
    },
    otIds: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...User.mapGetters({
      user: 'user',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    labelDate() {
      if (this.etat.etatSouhaite === ETAT_PLANIFIE) return this.$t('listeOtImpression.popUpSelectionTechnicien.datePlanification');
      return this.$t('listeOtImpression.popUpSelectionTechnicien.dateRealisation');
    },
    needDate() {
      return [ETAT_REALISE, ETAT_PLANIFIE].includes(this.etat.etatSouhaite);
    },
    techniciens() {
      return this.parametre(PARAMETRES_KEYS.utilisateur)
        ?.filter(user => user.estTechnicien) || [];
    },
    filteredTechniciens() {
      if (this.technicienNom === '') {
        return this.techniciens;
      }
      return this.techniciens.filter(technicien => {
        return technicien.decorator.nomPrenom.toLowerCase()
          .includes(this.technicienNom.toLowerCase());
      });
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    selectTechnicien(technicien) {
      this.selectedTechnicien = technicien;
    },
    handleEtatChanges() {
      this.etat.prisEnCompteEtat = true;
      this.etat.dateOt = null;
      if (this.needDate) this.etat.dateOt = new Date();
    },
    cancel() {
      this.$emit('cancel');
    },
    async validate() {
      const loadingComponent = this.$buefy.loading.open();
      this.messagesChampsVide = [];
      this.champsVide = [];
      this.messagesPopup = [];
      this.isErrorPopup = false;

      try {
        const userId = this.selectedTechnicien ? this.selectedTechnicien.id : null;
        await prendreEnCharge({
          userId: userId,
          ids: this.otIds,
          ...this.etat,
          dateOt: formatDate(this.etat.dateOt),
        });

        messageSucces(this.$i18n.t('listeOtImpression.popUpPriseEnCharge.success'));
        this.$emit('done');
        this.$parent.close();
      } catch (e) {
        if (e.response?.data?.error) {
          validationGeneral(
            this.$i18n,
            e.response,
            this.champsVide,
            this.messagesPopup,
            this.messagesChampsVide,
            translate,
          );
          validation(e.response, this.messagesPopup);
          this.isErrorPopup = true;
          return;
        }
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    modifyIsErrorPopup(value) {
      this.isErrorPopup = value;
    },
    onTechnicienInputChange(value) {
      if (!value.trim() || (this.selectedTechnicien
        && this.selectedTechnicien.decorator.nomPrenom !== value)) {
        this.selectedTechnicien = null;
      }
    },
    initialize() {
      const currentUser = this.techniciens.find(t => t.id === this.user.id);
      if (currentUser) {
        this.selectedTechnicien = currentUser;
        this.technicienNom = currentUser.decorator.nomPrenom;
      }
    },
  },
  async mounted() {
    try {
      await this.loadParametres([PARAMETRES_KEYS.utilisateur]);
      this.initialize();
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>

<style scoped>
</style>
